import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (
    // Skip for non-API requests
    !req.url.includes('/api/') ||
    // Skip interceptor for auth endpoints to prevent infinite loops
    req.url.includes('/api/auth/login') ||
    req.url.includes('/api/auth/refresh')
  ) {
    return next(req);
  }

  return from(authService.getToken()).pipe(
    switchMap((token) => {
      if (token === null) {
        router.navigate(['/login']);
        return throwError(() => new Error('No authentication token available'));
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(authReq);
    }),
    catchError((error) => {
      return throwError(() => error);
    }),
  );
};
